import React from 'react';
import flowRight from 'lodash.flowright';
import { withStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import { CircularProgress } from '@material-ui/core';
import clsx from 'clsx';

import withSettings from '../../../utils/withSettings';
import styles from '../styles';
import { translate } from '../../../i18n/I18nProvider';
import GroupingSelector from './GroupingSelector';
import { actions as reduxActions } from '../reducers';
import {
  getFilteredByAssignedOptions,
  getFilteredByExternalRangeOptions
} from '../../../consts/initialValues';

const ConnectRangesTableHeader = ({
  classes,
  isLoading,
  settings,
  showSelector,
  setMainSelected,
  mainSelected,
  externalRangeFilter,
  setExternalRangeFilter
}) => {
  const filterByAssignedOptions = getFilteredByAssignedOptions();
  const filterByExternalRangeOptions = getFilteredByExternalRangeOptions();

  return (
    <div
      className={classes.headerRoot}
      style={{ color: settings.colors.primary }}
    >
      <div className={classes.label}>
        <i className={clsx('fas fa-th-list', classes.icon)}></i>
        <div className={classes.title}>{translate('MENU.EXTERNAL_NUMBER')}</div>
        {isLoading ? <CircularProgress /> : null}
      </div>
      <div className={classes.headerSelectContainer}>
        {showSelector && (
          <GroupingSelector
            options={filterByExternalRangeOptions}
            setFunction={setExternalRangeFilter}
            value={externalRangeFilter}
            name="External Range"
          />
        )}
        {showSelector && (
          <GroupingSelector
            options={filterByAssignedOptions}
            setFunction={setMainSelected}
            value={mainSelected}
            name="Assigned"
          />
        )}
      </div>
    </div>
  );
};

const mapStatesToProps = ({ loader, externalNoRanges }) => {
  return {
    mainSelected: externalNoRanges.mainSelected,
    externalRangeFilter: externalNoRanges.externalRangeFilter,
    isLoading: loader.isSpinVisible
  };
};

const mapDispatchToProps = {
  setMainSelected: reduxActions.setMainSelected,
  setExternalRangeFilter: reduxActions.setExternalRangeFilter
};

export default flowRight(
  withSettings,
  connect(mapStatesToProps, mapDispatchToProps),
  withStyles(styles)
)(ConnectRangesTableHeader);
